import * as React from 'react';
import * as moment from 'moment';
import {option} from "ts-option";
import DateUtils from "../../../utils/DateUtils";
import DatePickerComponent from "./DatePickerComponent";
import * as classNames from "classnames";
import FormGroup from '../../../hiberUiKit/src/molecules/FormGroup/FormGroup';

interface ComponentProps {
	/**
	 * Start date of date range.
	 */
	from: moment.Moment;
	/**
	 * End date of date range.
	 */
	to: moment.Moment;
	/**
	 * Indicates if date pickers should be displayed in separate rows.
	 */
	displayBlock?: boolean;
	/**
	 * On date change
	 * @param dateFrom
	 * @param dateTo
	 */
	onChange: (dateFrom: moment.Moment, dateTo: moment.Moment) => void

	/**
	 * Max dates range (in months)
	 */
	range?: number
}

type Props = ComponentProps

export default class DateRangePickerComponent extends React.Component<Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onDateFromChange = this.onDateFromChange.bind(this);
		this.onDateToChange = this.onDateToChange.bind(this);
	}

	render() {
		const classFromProps = classNames({
			"c-date-range-picker": true,
			"isDisplayBlock": Boolean(this.props.displayBlock)
		});

		return (
			<div className={classFromProps}>
				<FormGroup label={"Date from"}>
					<DatePickerComponent dateFormat={DateUtils.DATE_FORMAT}
										 value={option(this.props.from)}
										 onChange={(value) => this.onDateFromChange(value.orNull)}/>
				</FormGroup>
				<FormGroup label={"Date to"}>
					<DatePickerComponent dateFormat={DateUtils.DATE_FORMAT}
										 value={option(this.props.to)}
										 onChange={(value) => this.onDateToChange(value.orNull)}/>
				</FormGroup>
			</div>
		);
	}

	/**
	 * Date from change callback.
	 * @param {moment.Moment} dateFrom
	 */
	onDateFromChange(dateFrom: moment.Moment) {
		if (dateFrom.isAfter(this.props.to, "day")) {
			this.props.onChange(dateFrom, dateFrom)
		}
		else if (this.props.range && dateFrom.isBefore(moment(this.props.to).subtract(this.props.range, "months"), "date")) {
			this.props.onChange(dateFrom, moment(dateFrom).add(this.props.range, "months"))

		}
		else {
			this.props.onChange(dateFrom, this.props.to);
		}
	}

	/**
	 * Date to change callback.
	 * @param {moment.Moment} dateTo
	 */
	onDateToChange(dateTo: moment.Moment) {
		if (dateTo.isBefore(this.props.from, "day")) {
			this.props.onChange(dateTo, dateTo);
		}
		else if (this.props.range && dateTo.isAfter(moment(this.props.from).add(this.props.range, "months"), "date")) {
			this.props.onChange(dateTo, moment(dateTo).subtract(this.props.range, "months"))
		}
		else {
			this.props.onChange(this.props.from, dateTo);
		}
	}
}
